import { Component, OnInit, Input } from '@angular/core';

import { Offer } from '../../../shared/models/offer';

@Component({
  selector: 'app-offer-form-recipients',
  templateUrl: './offer-form-recipients.component.html',
  styleUrls: ['./offer-form-recipients.component.sass']
})
export class OfferFormRecipientsComponent implements OnInit {
  @Input() model: Offer;

  constructor() { }

  ngOnInit() {
  }

}
